import { PATH_NAME } from 'configs/pathName';
import { useGlobalContext } from 'context/GlobalContext';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

function AuthGuard() {
  const { user } = useGlobalContext();

  const username = user.username;

  console.log(username, "ee")


  const isAuth = user.userId;

  console.log(isAuth, "auth")

  if (!isAuth && !username) return <Navigate to={PATH_NAME.LOGIN} />;
  if (!isAuth) return <Navigate to={PATH_NAME.SELECT_METHOD} />;

  return <Outlet />;
}

export default AuthGuard;